"use client";

import { c as _c } from "react/compiler-runtime";
import { EntityMenu, MenuActionType, type ActionGroup } from "@/src/components/menus/entity-menu";
interface CardActionsProps {
  isContextMenu?: boolean;
  id: string;
  label: string;
  href?: string;
  customProps?: {
    label: string;
    onClick: () => void;
  }[];
}
export function CardActions(t0) {
  const $ = _c(10);
  const {
    isContextMenu: t1,
    id,
    label,
    href,
    customProps
  } = t0;
  const isContextMenu = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== customProps) {
    t2 = customProps?.length ? [customProps.map(_temp)] : [];
    $[0] = customProps;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const actionGroups = t2;
  let t3;
  if ($[2] !== href || $[3] !== id || $[4] !== label) {
    t3 = {
      href,
      id,
      label
    };
    $[2] = href;
    $[3] = id;
    $[4] = label;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== actionGroups || $[7] !== isContextMenu || $[8] !== t3) {
    t4 = <EntityMenu isContextMenu={isContextMenu} entity={t3} actionGroups={actionGroups} className="w-40" />;
    $[6] = actionGroups;
    $[7] = isContextMenu;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp(prop) {
  return {
    type: MenuActionType.Item,
    label: prop.label,
    onClick: prop.onClick
  };
}
interface CreateCardActionsPropsParams {
  id: string;
  label: string;
  href?: string;
  customProps?: {
    label: string;
    onClick: () => void;
  }[];
}
export function createCardActionsProps({
  id,
  label,
  href,
  customProps
}: CreateCardActionsPropsParams) {
  return {
    id,
    label,
    href,
    customProps
  };
}